import { useState, useEffect } from 'react';
import {
    TextField,
    Backdrop,
    Stack,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Paper,
} from '@mui/material';
import Swal from 'sweetalert2';

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

const apiUrl = process.env.REACT_APP_API_URL;

const EditPaymentMethod = ({ open, onClose, onUpdate, pm = {} }) => {

    const [accName, setAccName] = useState("");
    const [accNumber, setAccNumber] = useState("");
    const [accType, setAccType] = useState("");

    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (pm) {
            setAccName(pm.AccName ?? "");
            setAccNumber(pm.AccNumber ?? "");
            setAccType(pm.AccType ?? "");
        }
    }, [pm]);

    const handleEdit = async () => {
        setIsSaving(true);
        try {
            const response = await fetch(`${apiUrl}manage_payment_method/edit_paymethod.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: pm.id,
                    accName: accName,
                    accNumber: accNumber,
                    accType: accType,
                })
            });

            const result = await response.json();

            if (result.status === 'success') {

                onUpdate({
                    id: pm.id,
                    AccName: accName,
                    AccNumber: accNumber,
                    AccType: accType,
                });

                Swal.fire({
                    icon: "success",
                    text: result.message,
                    timer: 3500,
                    showConfirmButton: false,
                });

                handleClose();

            } else if (result.status === 'error') {
                Swal.fire({ text: result.message, icon: "error" });
            }
        } catch (error) {
            Swal.fire({ title: 'Error saving user!', text: error, icon: "error" });
            console.error('Error saving list:', error);
        } finally {
            setIsSaving(false);
        }
    };

    const handleClose = () => {
        setAccName("");
        setAccNumber("");
        setAccType("GCash");
        onClose();
    }

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >
            <Paper
                sx={{
                    width: 400,
                    p: 3,
                    borderRadius: 2,
                    position: "relative",
                    overflow: "hidden",

                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >
                <CustomModalHeader
                    title="Edit Payment Method"
                    subtitle="Edit payment method"
                    onClose={onClose}
                />

                <Stack direction="column" gap={2} mt={1}>
                    <TextField
                        label="Account Name"
                        size='small'
                        autoComplete="off"
                        value={accName}
                        onChange={(e) => setAccName(e.target.value)}
                    />
                    <TextField
                        label="Account Number"
                        size='small'
                        autoComplete="off"
                        value={accNumber}
                        onChange={(e) => setAccNumber(e.target.value)}
                    />
                    <FormControl fullWidth size='small'>
                        <InputLabel id="demo-simple-select-label">Account Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={accType}
                            label="Account Type"
                            onChange={(e) => setAccType(e.target.value)}
                        >
                            <MenuItem value="GCash">GCash</MenuItem>
                            <MenuItem value="BDO">BDO</MenuItem>
                            <MenuItem value="Maya">Maya</MenuItem>
                            <MenuItem value="Palawan">Palawan</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>

                <Stack direction="row" spacing={2} mt={3} justifyContent="flex-end">
                    <CustomButton
                        label="Cancel"
                        variant="outlined"
                        hoverColor="#d14249"
                        onClick={onClose}
                    />
                    <CustomButton
                        label={isSaving ? "Saving..." : "Save"}
                        disabled={isSaving}
                        onClick={handleEdit}
                    />
                </Stack>

            </Paper>

        </Backdrop>
    );
};

export default EditPaymentMethod;
